import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=f2b32180&"
import script from "./ProgressBar.vue?vue&type=script&lang=js&"
export * from "./ProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b32180')) {
      api.createRecord('f2b32180', component.options)
    } else {
      api.reload('f2b32180', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=f2b32180&", function () {
      api.rerender('f2b32180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/ProgressBar.vue"
export default component.exports